import firebase from 'firebase/compat/app';
import { set, addElementToArray, update, removeElementToArray, remove, getNewDocumentId } from '@/firebase/firestoreFunctions';

export const pingReflection = async (id) => {
  try {
    return await firebase.firestore().collection('reflections').doc(id).get();
  } catch (e) {
    console.log('Error pingReflection', e);
    throw e;
  }
};

export function createCategory(labels) {
  return { id: getNewDocumentId(), labels, analyses: [], categories: [] };
}

export const createDefaultReflectionCategories = () => ({
  general: { analyses: [], categories: {}, id: 'general', sort: 0 },
  objectives: { analyses: [], categories: {}, id: 'objectives', sort: 1 },
  strategies: { analyses: [], categories: {}, id: 'strategies', sort: 2 },
  tactics: { analyses: [], categories: {}, id: 'tactics', sort: 3 },
  additionalInfos: { analyses: [], categories: {}, id: 'additionalInfos', sort: Number.MAX_SAFE_INTEGER },
});

export const createDefaultReflectionDocumentRetentions = (defaultRetentionStatus) => ({
  categories: ['general'],
  retentionStatus: { general: defaultRetentionStatus },
  retentionElements: {},
});

export const editReflection = async (id, edit) => {
  try {
    return await update('reflections', id, edit);
  } catch (e) {
    console.log('Error editReflection', e);
    throw e;
  }
};

export const saveNewReflection = async (id, newReflection) => {
  try {
    return await set('reflections', id, newReflection);
  } catch (e) {
    console.log('Error saveNewReflection', e);
    throw e;
  }
};

export const removeReflectionDocument = (id, reflectionId) => {
  try {
    return remove(`reflections/${reflectionId}/reflectionDocuments`, id);
  } catch (e) {
    console.log('Error removeReflectionDocument', e);
    throw e;
  }
};

export const setReflectionDocument = async (id, reflectionId, newReflectionDocument) => {
  try {
    return await set(`reflections/${reflectionId}/reflectionDocuments`, id, newReflectionDocument);
  } catch (e) {
    console.log('Error setReflectionDocument', e);
    throw e;
  }
};

export const updateReflectionDocument = async (id, reflectionId, edit) => {
  try {
    return await update(`reflections/${reflectionId}/reflectionDocuments`, id, edit);
  } catch (e) {
    console.log('Error updateReflectionDocument', e);
    throw e;
  }
};

export const addReflectionDocumentToReflection = async (id, reflectionId) => {
  try {
    return await addElementToArray('reflections', reflectionId, 'reflectionDocumentIds', id);
  } catch (e) {
    console.log('Error addReflectionDocumentToReflection', e);
    throw e;
  }
};

export const removeReflectionDocumentToReflection = (id, reflectionId) => {
  try {
    return removeElementToArray('reflections', reflectionId, 'reflectionDocumentIds', id);
  } catch (e) {
    console.log('Error removeReflectionDocumentToReflection', e);
    throw e;
  }
};

export const addReflectionReport = async (reflectionId, reportId) => {
  try {
    return await set(`reflections/${reflectionId}/reflectionReports`, reportId, { id: reportId });
  } catch (e) {
    console.log('Error addReflectionReport', e);
    throw e;
  }
};

export const setReflectionReport = async (reflectionId, reportId, edit) => {
  try {
    return await set(`reflections/${reflectionId}/reflectionReports`, reportId, edit);
  } catch (e) {
    console.log('Error setReflectionReport', e);
    throw e;
  }
};

export const updateReflectionReport = async (reflectionId, reportId, edit) => {
  try {
    return await update(`reflections/${reflectionId}/reflectionReports`, reportId, edit);
  } catch (e) {
    console.log('Error setReflectionReport', e);
    throw e;
  }
};
